<title>{{ ndcTechnicalFaqPage.htmlTitle }}</title>
<app-banner [banner]="ndcTechnicalFaqPage.banner"></app-banner>
<div class="container innerContent faqpages">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [isInnerBorder]="true" [sections]="ndcTechnicalFaqPage.sections"></app-border-section>
</div>
